module.exports = __webpack_public_path__ + "static/img/sch-102.133b4e06.png";